import React, { useState } from 'react';
import './SettingsPage.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useAuth } from '../../AuthContext';
import { Link } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const SettingsPage = () => {
    const { user } = useAuth();
    const userDetails = user.user;

    const [formData, setFormData] = useState({

        username: userDetails.username || '',
        mobile: userDetails.mobile || '',
        email: userDetails.email || '',
        role: userDetails.role || '',
        address: userDetails.address || '',
        date_of_birth: userDetails.date_of_birth || '',
        blood_group: userDetails.blood_group || '',
        id_proof: userDetails.id_proof || '',
        id_proof_number: userDetails.id_proof_number || '',
        work_type: userDetails.work_type || '',
        previous_work: userDetails.previous_work || '',
        previous_work_with: userDetails.previous_work_with || '',
        reference_name: userDetails.reference_name || '',
        password: userDetails.password || '',
        confirm_password: userDetails.confirm_password || '',
        total_task_count: userDetails.total_task_count || '',
        total_distance_count: userDetails.total_distance_count || '',
        total_present_days_count: userDetails.total_present_days_count || '',
        total_absent_days_count: userDetails.total_absent_days_count || '',
        uuId: userDetails.uuId || '',
        manager: userDetails.manager || '',
        punch_In: userDetails.punch_In || '',
        punch_out: userDetails.punch_out || '',
        total_hour: userDetails.total_hour || '',
        profile: userDetails.profile || '',
        date_of_join: userDetails.date_of_join || '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const updateTask = async () => {
        try {
          const response = await axios.put(API_URL + `/user/${userDetails.username}`, formData);
    
          if (response.status === 200) {
            console.log('User updated successfully');
            window.alert('User updated successfully!')
            sessionStorage.removeItem('user');
        window.location.reload(true);
        window.location.href = '/SignIn'
          } else {
            console.error('Error updating user');
          }
        } catch (error) {
          console.error(error);
        }
      };

    return (
        <div className="settings_page">
            <SideMenuBar />

            <div className="content">
                <NewHeader />

                <main className="settings_container">
                    <section className="settings_hero">
                        <div>
                            <span className="settings_kicker">Account management</span>
                            <h1 className="settings_title">Settings</h1>
                            <p className="settings_subtitle">
                                Manage your profile information and account preferences.
                            </p>
                        </div>

                        <div className="settings_identity">
                            <span>Signed in as</span>
                            <strong>{formData.username || 'User'}</strong>
                            <small>{formData.role || 'Account'}</small>
                        </div>
                    </section>

                    <section className="settings_panel">
                        <nav className="settings_tabs" aria-label="Settings sections">
                            <Link to="/SettingsPage" className="settings_tab active">
                                Profile
                            </Link>
                            <Link to="/SettingPswd" className="settings_tab">
                                Password
                            </Link>
                            <Link to="/SettingReport" className="settings_tab">
                                Report
                            </Link>
                        </nav>

                        <form
                            className="settings_form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                updateTask();
                            }}
                        >
                            <div className="settings_section_header">
                                <div>
                                    <span className="settings_eyebrow">Profile</span>
                                    <h2>Personal information</h2>
                                    <p>Update the contact details associated with your account.</p>
                                </div>
                            </div>

                            <div className="settings_profile_card">
                                <div className="settings_avatar">
                                    <img src="../assets/gallery.png" alt="Profile" />
                                </div>

                                <div className="settings_profile_copy">
                                    <strong>Profile picture</strong>
                                    <p>Use a clear image for your account profile.</p>
                                    <a href="/" className="settings_upload_link">
                                        Change profile picture
                                    </a>
                                </div>
                            </div>

                            <div className="settings_divider" />

                            <div className="settings_form_grid">
                                <div className="settings_field">
                                    <label>Full Name</label>
                                    <input
                                        placeholder="Enter full name"
                                        name="username"
                                        value={formData.username}
                                        readOnly
                                        disabled
                                    />
                                    <small>This field is managed by your account.</small>
                                </div>

                                <div className="settings_field">
                                    <label>Username</label>
                                    <input
                                        placeholder="Enter username"
                                        name="username"
                                        value={formData.username}
                                        readOnly
                                        disabled
                                    />
                                    <small>Your username cannot be changed here.</small>
                                </div>

                                <div className="settings_field">
                                    <label>Email ID</label>
                                    <input
                                        type="email"
                                        placeholder="Enter email address"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="settings_field">
                                    <label>Phone No.</label>
                                    <input
                                        placeholder="Enter phone number"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <footer className="settings_form_footer">
                                <span>Changes will update your account information.</span>
                                <button type="submit" className="update_btn_SettingsPage">
                                    Save changes
                                </button>
                            </footer>
                        </form>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default SettingsPage;